var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{formGroup: true, isRequired: _vm.itemSetting.action.isRequired}},[_c('div',{staticClass:"label",style:(_vm.labelStyle)},[_vm._v(_vm._s(_vm.itemSetting.action.label[_vm.activeLang]))]),_c('div',{staticClass:"signaturePad"})])
}
var staticRenderFns = []

export { render, staticRenderFns }